import { render, staticRenderFns } from "./DisclaimerQuestion1.vue?vue&type=template&id=4a90d7f5&scoped=true&"
import script from "./DisclaimerQuestion1.vue?vue&type=script&lang=js&"
export * from "./DisclaimerQuestion1.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerQuestion1.vue?vue&type=style&index=0&id=4a90d7f5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90d7f5",
  null
  
)

export default component.exports